import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { IsStringPipe } from '../pipes/is-string.pipe';
import { MatButtonModule } from '@angular/material/button';
import { trackByTextFn } from './trackByFunctions.utils';

@Component({
  selector: 'app-dialog-message',
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    @if (!data.useHtmlContent) {
      <div mat-dialog-content style="white-space: pre-line">
        {{ data.message }}
      </div>
    }

    @if (data.useHtmlContent) {
      <div mat-dialog-content [innerHTML]="data.message"></div>
    }
    <div
      mat-dialog-actions
      align="end"
      [class]="data.columnForButton ? 'd-flex-column' : ''"
    >
      @if (data.buttons | isString) {
        <button mat-button (click)="defaultHandler()">
          {{ data.buttons }}
        </button>
      }
      @if (!(data.buttons | isString)) {
        @for (
          button of data.buttons;
          let i = $index;
          track trackByFn(i, button)
        ) {
          <button mat-button (click)="handler(button)">
            {{ button.text }}
          </button>
        }
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, IsStringPipe],
})
export class DialogMessageComponent {
  trackByFn = trackByTextFn;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    private dialogRef: MatDialogRef<DialogMessageComponent>
  ) {}

  public defaultHandler() {
    this.dialogRef.close();
  }

  public handler(button: { text: string; handler: () => void }) {
    if (button.handler) button.handler();
    this.dialogRef.close();
  }
}

interface DialogData {
  title: string;
  message: string;
  button: string;
  buttons: string | { text: string; handler: () => void }[];
  columnForButton?: boolean;
  useHtmlContent?: boolean;
}
